var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Item"},[_c('headerItemDv1',{attrs:{"msg":"白名单授信列表"}}),_c('div',{staticClass:"grid-container"},[_c('dv-scroll-board',{staticClass:"f-28",staticStyle:{"width":"100%","height":"400px","font-size":"28px"},attrs:{"config":_vm.config,"waitTime":1000000}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }